module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7541a408ec69080501071d6f06d6bcce.png";